import { useState } from 'react'
import FormErrors from '../../components/FormErrors'
import { login } from '../../lib/allauth'
import { Link, useNavigate } from 'react-router-dom'
import { useConfig } from '../../auth'
import ProviderList from '../../socialaccount/ProviderList'
import { Box, Typography, styled } from '@mui/material';
import BaseButton from '../../components/BaseButton'
import BackgroundContainer from '../../components/BackgroundContainer'
import BaseTextField from '../../components/BaseTextField'
import BaseHeader from '../../components/BaseHeader'
import BaseFormContainer from '../../components/BaseFormContainer';

const Subtitle = styled(Typography)({
  fontFamily: 'Playfair Display, serif',
  fontSize: '1.05rem',
  color: '#ffbfe1',
  textAlign: 'center',
  textShadow: '0px 2px 6px rgba(0, 0, 0, 0.5)',
  lineHeight: '1.4',
});


export default function Login () {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [response, setResponse] = useState({ fetching: false, content: null })
  const config = useConfig()
  const navigate = useNavigate()
  const hasProviders = config?.data?.socialaccount?.providers?.length > 0;

  function submit () {
    setResponse({ ...response, fetching: true })
    login({ email, password }).then((content) => {
      setResponse((r) => { return { ...r, content } })
    }).catch((e) => {
      console.error(e)
      window.alert(e)
    }).then(() => {
      setResponse((r) => { return { ...r, fetching: false } })
    })
  }

  return (
    <BackgroundContainer  sx={{overflowY : 'hidden'}} > 
      <BaseFormContainer sx={{
    width: '100%',
    height: '100%',
    padding: { xs: 2, sm: 3 },
    boxSizing: 'border-box',
    marginBottom: '20px',
    marginTop: '10px',
  }} >
      <BaseHeader sx={{
    marginBottom: '1rem',
    textAlign: 'center',
    fontSize: '5rem', 
    '@media (max-width: 360px)': {
      fontSize: '4rem',
    },
    '@media (max-width: 340px)': {
      fontSize: '3.3rem', // 🧠 Gentle scale-down on ultra-small screens
    },
    '@media (max-width: 320px)': {
      fontSize: '3.2rem', // 🔒 Last-resort fallback for smallest devices
    },
  }}>Login</BaseHeader>
      <Subtitle sx={{
    marginBottom: '20px',
    fontSize: '1.2rem',
    '@media (max-width: 400px)': {
      fontSize: '1.1rem',
    },
    '@media (max-width: 360px)': {
      fontSize: '1rem',
    },
    '@media (max-width: 320px)': {
      fontSize: '0.95rem',
    },
  }}>
        No account? <Link to='/account/signup' style={{ color: '#E91E63' }}>Sign up here.</Link>
      </Subtitle>
      
      <FormErrors errors={response.content?.errors} />
      <Box display="flex" flexDirection="column" justifyContent='center' alignItems="center">
      <BaseTextField
        value={email}
        sx={{
          width: '100%',
          maxWidth: '250px', // 📏 Looks good on larger screens
          fontSize: '1.1rem',
          '@media (max-width: 420px)': {
            marginBottom: '10px',
          },
          '& .MuiInputBase-input': {
            padding: '12px',
            fontSize: '1.1rem',
            '@media (max-width: 360px)': {
              padding: '10px',
              fontSize: '1rem', // 🧠 Slightly smaller on small phones
            },
            '@media (max-width: 320px)': {
              padding: '8px',
              fontSize: '0.95rem', // 🧬 Tighter on very narrow phones
            },
          },
        }}
        onChange={(e) => setEmail(e.target.value)}
        type='email'
        label="Email"
        required
        variant="outlined"
      />
      <FormErrors param='email' errors={response.content?.errors} />

      <BaseTextField
        value={password}
        sx={{
          width: '100%',
          maxWidth: '250px', // 📏 Looks good on larger screens
          fontSize: '1.1rem',
          '@media (max-width: 420px)': {
            marginBottom: '10px',
          },
          '& .MuiInputBase-input': {
            padding: '12px',
            fontSize: '1.1rem',
            '@media (max-width: 360px)': {
              padding: '10px',
              fontSize: '1rem', // 🧠 Slightly smaller on small phones
            },
            '@media (max-width: 320px)': {
              padding: '8px',
              fontSize: '0.95rem', // 🧬 Tighter on very narrow phones
            },
          },
        }}
        onChange={(e) => setPassword(e.target.value)}
        type='password'
        label="Password"
        required
        variant="outlined"
      />
      <Link to='/account/password/reset' style={{ color: '#E91E63', marginTop: '10px', display: 'block' }}>
        Forgot your password?
      </Link>
      <FormErrors param='password' errors={response.content?.errors} />

      <BaseButton sx={{
    minWidth: '75%',
    marginTop: '14px',
    fontSize: '1.1rem',
    '@media (max-width: 360px)': {
      fontSize: '1rem',
      minWidth: '80%',
    },
    '@media (max-width: 320px)': {
      fontSize: '0.95rem',
      minWidth: '85%',
    },
  }} disabled={response.fetching} onClick={() => submit()}>
        Login
      </BaseButton>
      
      <BaseButton sx={{
    minWidth: '75%',
    marginTop: '14px',
    fontSize: '1.1rem',
    '@media (max-width: 360px)': {
      fontSize: '1rem',
      minWidth: '80%',
    },
    '@media (max-width: 320px)': {
      fontSize: '0.95rem',
      minWidth: '85%',
    },
  }} disabled={response.fetching} onClick={() => navigate("/")}>
        Back To Home Page
      </BaseButton>
      </Box>
      {config.data.account.login_by_code_enabled && (
        <Link to='/account/login/code' style={{ color: '#E91E63', marginTop: '10px',  }}>
          Mail me a sign-in code
        </Link>
      )}

      {hasProviders && (
        <>
          <ProviderList callbackURL='/account/provider/callback' />
        </>
      )}
      </BaseFormContainer>
    </BackgroundContainer>
  )
}